module.exports = __webpack_public_path__ + "img/av (4).55c0ba78.png";